import styled from 'styled-components';

export const FooterWrapperStyled = styled.div`
  background-color: #1f1f1f;
  padding: 50px 20px 30px 20px;
  width: 100%;

  & .content {
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
  }

  & .footer-text {
    color: #b3b3b3;
    font-size: 12px;
    line-height: 15px;
  }
  & .footer-text:first-child {
    padding-right: 10px;
  }
  & .footer-text + .footer-text {
    border-left: 1px solid #b3b3b3;
    padding: 0px 10px;
  }

  @media (max-width: 640px) {
    & .footer-text:first-child {
      width: 100%;
      text-align: center;
      margin-bottom: 6px;
      padding-right: 0px;
    }
    & .footer-text + .footer-text {
      border-left: none;
    }
    & .footer-text:last-child {
      border-left: 1px solid #b3b3b3;
    }
  }
`;

export const Container = styled.div`
  max-width: 1450px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  width: 100%;
  gap: 50px;
  padding: 0px 30px 30px;
  justify-content: space-between;

  @media (max-width: 1080px) {
    flex-wrap: wrap;
  }
`;

export const Logo = styled.div`
  display: flex;
  flex-shrink: 0;
  gap: 10px;
  min-width: 200px;
  margin-right: 30px;
  & img {
    height: 45px;
    width: 45px;
    object-fit: contain;
    flex-shrink: 0;
  }

  @media (max-width: 640px) {
    width: 100%;
    min-width: 100%;
  }
`;

export const Text = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  & .text {
    color: white;
  }
`;

export const FooterSectionStyled = styled.div`
  min-width: 100px;
  flex-shrink: 0;
  & .title {
    margin-bottom: 16px;
    font-size: 16px;
    line-height: 25px;
  }

  & .menu {
    margin-bottom: 12px;

    & .menu-item {
      font-size: 14px;
      line-height: 18px;
      font-weight: 400;
      cursor: pointer;
    }
  }
`;
